<template>
    <div class="message" ref="messageContainer">
      <ul v-if="session" class="no-bullets">
        <li v-for="item in session.messages" :key="item.date">
          <p class="time">
            <span>{{ formatTime(item.date) }}</span>
          </p>
          <div class="main noself" :class="{ self: item.self }">
            <!-- <div class="text">{{ item.content }}</div> -->
            <template v-if="isImageUrl(item.content)">
              <img :src="item.content" alt="Image Message" class="message-image">
            </template>
            <template v-else>
              <div class="text">{{ item.content }}</div>
            </template>
          </div>
        </li>
      </ul>
    </div>
  </template>
  
  
  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import { computed, ref, onUpdated, onMounted,onUnmounted } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  import { NavigationFailureType } from 'vue-router';
  const imageUrl = ref(null);
  import { TelegramClient } from "@/websocket/Client";
  // /:src="item.self ? user.img : session.user.img"
  // 定义接口 (类型)
  interface MessageItem {
    date: string | Date;
    self: boolean;
    content: string;
  }
  
  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: MessageItem[];
  }
  
  interface User {
    name: string;
    imgId: number;
  }
  
  // 获取 store
  const store = useStore();
  
  // 使用 ref 创建 messageContainer
  const messageContainer = ref<HTMLElement | null>(null);
  
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
 

  // 当前会话 (计算属性)
  const session = computed<Session | undefined>(() => {
    var ses = store.state.sessions.find((session: Session) => session.id === store.state.currentSessionId);
    return ses;
  });


  const  getImageUrl =  (item:any, user:any, session:any)=>
  {
    var headId = item.self ? user.imgId : session.user.imgId
    var imgUrl = ExternalFun.getImageUrl(headId);
    return imgUrl;
  }

  const isImageUrl = (url)=> {
      if (!url) return false;
      url = url.toLowerCase();
      return (url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.gif') || url.endsWith('.svg') || url.startsWith('data:image'));
    }

  
  // 时间格式化函数 (替代 filters)
  const formatTime = (date: string | Date): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.getHours() + ':' + d.getMinutes();
  };
  
  // 滚动到底部的函数 (替代指令)
  const scrollToBottom = () => {
    if (messageContainer.value) {
      const el = messageContainer.value;
      el.scrollTop = el.scrollHeight - el.clientHeight;
    }
  };
  
  // 在每次 session.messages 更新后滚动到底部
  onUpdated(scrollToBottom);

  const handChatData = (newMessage)=>{

    console.log("handChatData="+newMessage);
    if(newMessage.detail&&newMessage.detail.detail)
    {
        var name = store.state.user.name;
        var message = newMessage.detail.detail
        var recipientPhone = message.recipientPhone;
        var data = message.messages[0];
        var senderId = data.senderId;
        var timestamp = data.timestamp * 1000;
        if(name == recipientPhone)
        {
          let session = store.state.sessions.find((item) => item.id === senderId);
          if (session) {
            session.messages.push({
              content: data.content,
              date: new Date(timestamp),
              self: false,
            });
          }
        }
    }

  }    


 
onMounted(() => {
  var tt1 = new Date();
  console.log("message onMounted="+tt1.getTime());
  const client = TelegramClient.getInstance();
  client.addChatUpdateListener(handChatData);
  setTimeout(() => {
    scrollToBottom();
        }, 1000);
});

onUnmounted(() => {

const client = TelegramClient.getInstance();
client.removeChatUpdateListener(handChatData);
 

});


  </script>

  
  <style lang="less" scoped>
  .message {
    padding: 10px 15px;
    overflow-y: scroll;
  
    li {
      margin-bottom: 15px;
    }
  
    .time {
      margin: 7px 0;
      text-align: center;
  
      > span {
        display: inline-block;
        padding: 0 18px;
        font-size: 12px;
        color: #fff;
        border-radius: 2px;
        background-color: #dcdcdc;
      }
    }
  
    .avatar {
      float: left;
      margin: 0 10px 0 0;
      border-radius: 3px;
    }

    .no-bullets {
      list-style-type: none;
      padding-left: 0; /* 移除默认的缩进 */
    }
  
    .text {
      display: inline-block;
      position: relative;
      padding: 0 10px;
      max-width: calc(100% - 40px); 
      min-height: 30px;
      line-height: 2.5;
      font-size: 12px;
      text-align: left;
      word-break: break-all;
      background-color: #fafafa;
      border-radius: 4px;
  
      &:before {
        content: " ";
        position: absolute;
        top: 9px;
        right: 100%;
        border: 6px solid transparent;
        border-right-color: #fafafa;
      }
    }

   .noself{
    text-align: left;
   }

   .message-image {
    max-width: 100%;
    max-height: 100%;
  }
    
  
    .self {
      text-align: right;
  
      .avatar {
        float: right;
        margin: 0 0 0 10px;
      }
  
      .text {
        background-color: #b2e281;
  
        &:before {
          right: auto; /* 将 right 设置为 auto */
          left: 100%;
          border-right-color: transparent;
          border-left-color: #b2e281;
        }
      }
    }
  }
  </style>